(ns hai.admin-ui.users.edit
  "User edit page"
  (:require
   [field :as-alias field]
   [hai-model.model :as model]
   [hai.entity.helpers :as entity]
   [hai.users.helper :as users.helper]
   [hai.ui.components :as c]
   [hai.ui.components.form.core :as form]
   [hai.ui.components.form.input :as input]
   [hai.ui.rf-sugar :refer [<s >e defsub]]
   [hai.web-app.components.form :as form-old]
   [hai.web-app.layout :as layout]
   [lambdaisland.ornament :as o]))

(o/defstyled render :div
  :flex :flex-col :gap-3
  :w-100
  [:.buttons :flex :flex-row :gap-3]
  ([{:form/keys [fields valid? on-submit submitting?] :as form-props}]
   (let [{:user/keys [full-name email]} fields]
     [:<>

      ;; NOTE does not update actual user
      ;; [:div
      ;;  [form/label email]
      ;;  [form/list-of form/removable-input email]]
      [:div
       [form/label full-name]
       [input/field full-name]]
      [:div.buttons
       [c/Button
        {:disabled (or (not valid?)
                       submitting?)
         :on-click on-submit
         :size "2"}
        "Update"]
       [c/Button
        {:disabled submitting?
         :size "2"
         :color "crimson"
         :variant "outline"}
        "Cancel"]]])))

(defsub :user
  [db id]
  (let [id (some-> (or id (get-in db [:routing/current-route :path-params :user/uuid]))
                   ((comp uuid str)))]
    (get-in db [:user/uuid id])))

(o/defstyled user-form form-old/form
  ([]
   [form/component
    {:id ::form
     :render render
     :schema model/User
     :initial-value-sub :user
     :on-submit (fn [valid-user]
                  (>e [:resolve [(list 'user/update valid-user)]
                       ;; TODO form validation and error states
                       {:on-success-fx [[:dispatch [:form/submitted ::form]]
                                        [:dispatch [:routing/navigate [:users]]]]}]))}]))

(defn page
  [_]
  (let [user @(<s [:user])]
    [layout/page
     [layout/breadcrumbs {:breadcrumbs [(users.helper/->label user)]}]
     [layout/heading {:label (users.helper/->label user)}]
     [layout/content
      [user-form]]]))

(defn route
  []
  ["/edit/{user/uuid}"
   {:name :users/edit
    :view page
    :controllers [{:parameters {:path [:user/uuid]}
                   :start (fn [{user :path}]
                            (let [ident (entity/->ident user)
                                  query (entity/->pull-query model/User)]
                              (>e [:resolve [{ident query}]
                                   {:transform-fn (fn [res]
                                                    (get res ident))
                                    :store-in ident}])))}]}])
